// SYSTEM
function DataItem(aType) {
    "use strict";

    this.ShortName = aType;
    this.FullName = 'Veritracks.Core.' + aType;
    this.AssemblyQualifiedName = 'Veritracks.Core.' + aType + ', Veritracks.Core, Culture=neutral, PublicKeyToken=null'; //Version=2011.10.4374.18013,
}
if (typeof exports !== 'undefined') {
    module.exports = DataItem;
}